import $profile from 'stores/profile'
import $global from 'stores/global'

const __default__ = {
  methods: {
    async onLogout() {
      await $global.logout()
    }
  }
}


export default /*@__PURE__*/Object.assign(__default__, {
  __name: 'navbar-profile',
  setup(__props, { expose: __expose }) {
  __expose();


const __returned__ = { get $profile() { return $profile }, get $global() { return $global } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})